<template>
  <div>
    <!-- 视频 -->
    <template>
      <el-row class="imgListFlow">
        <ul class>
          <li v-for="item in imgList" :key="item.id" :title="item.fileName">
            <div style="cursor: pointer;height:150px;" @click="gotoDetail(item.id)">
              <el-image style="width: 100%; height: 100%;" :src="item.fileLocation" fit="contain"></el-image>
            </div>
            <h4 style="margin-top:10px;">{{item.fileName}}</h4>
            <div>
              <button v-if="item.status == 1" class="cancelFavorite" @click="cancelFavorite(item.id)">取消收藏</button>
              <div v-else>已下线视频</div>
            </div>
            <div v-show="item.status == 0" class="maskbox"></div>
          </li>
        </ul>
      </el-row>
    </template>

    <!-- 专题 -->
    <!-- <template v-else>
      <el-row class="imgListFlow">
        <ul class>
          <li v-for="item in topicsList" :key="item.id" :title="item.title">
            <div style="cursor: pointer;" @click="gotoDetail(item.id)">
              <el-image style="width: 280px; height: 280px;" :src="item.surfacePlot" fit="contain"></el-image>
              <h4>{{item.title}}</h4>
            </div>
            <div>
              <button class="cancelFavorite" @click="cancelFavoriteTopic(item.id)">取消</button>
            </div>
          </li>
        </ul>
      </el-row>
    </template>-->
  </div>
</template>

<script>
import { async } from "q";
export default {
  props: {
    activeName: ""
  },
  data: function() {
    return {
      imgList: [
        // {
        //   id: "10",
        //   columId: null,
        //   fileName: "小艺720P花",
        //   fileGuid: "479ee0179ba54d568631697575ccdf05",
        //   fileLocation:
        //     "https://gong-xiang-ban-quan-tu-pian.oss-cn-beijing.aliyuncs.com/copyright/20190724/yt_path/5fd0019c6c2246caba3b8f60c15e5cd3.gif",
        //   fileLength: null,
        //   filePlayTime: null,
        //   fileFormat: "8K",
        //   fileSize: 11487403,
        //   columnName: "成品素材",
        //   filePath: "http://img.ksbbs.com/asset/Mon_1703/05cacb4e02f9d9e.mp4",
        //   fileTypeId: "FILETYPE_HIGHMP4",
        //   isElite: null,
        //   status: null,
        //   createTime: "2019-09-26 15:57:08"
        // }
      ],
      topicsList: [{}]
    };
  },
  methods: {
    VideoCollectList: async function() {
      console.log(this.activeName);
      // if (this.activeName == "first") {
      var res = await this.$http.get("/v1/collect/videoCollectList?page=1");
      var { code, data, message } = res.data;

      if (code == 0) {
        this.imgList = data;
        console.log(this.imgList);
      } else {
        this.$message.error(message);
      }
      // }
      // else {
      //   var res = await this.$http.get("/v1/collect/topicsCollectList?page=1");
      //   var { code, data, message } = res.data;

      //   if (code == 0) {
      //     this.topicsList = data;
      //     console.log(this.topicsList);
      //   } else {
      //     this.$message.error(message);
      //   }
      // }
    },
    // TopicsCollectList: async function() {
    //   var res = await this.$http.get("/v1/collect/topicsCollectList?id=?page=1");
    //   var { code, data, message } = res.data;

    //   if (code == 0) {
    //     this.imgList = data;
    //     console.log(this.imgList);
    //   } else {
    //     this.$message.error(message);
    //   }
    // },
    // 取消收藏
    cancelFavorite(picid) {
      this.$confirm("是否取消收藏？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          console.log(picid);
          var clres = await this.$http.post(
            `/v1/collect/collectionVideoInfo?id=${picid}`
          );
          var { code, message, data } = clres.data;
          if (code == 0) {
            this.$message.success("取消成功");
            this.VideoCollectList();
          }
          // var is_this = this;
          // clres.then(
          //   function(future) {
          //     var { code, message, data } = future.data;
          //     if (code == 0) {
          //       //alert(data);
          //       //location.reload();
          //       this.VideoCollectList();
          //       is_this.$message({
          //         type: "success",
          //         duration: 1600,
          //         message: data,
          //         onClose: function() {
          //           is_this.$router.go(0);
          //         }
          //       });
          //     }
          //   },
          //   function(error) {}
          // );
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消操作"
          // });
        });
    },
    gotoDetail: function(id) {
      this.$router.push({
        path: "/videodetail2",
        query: {
          id: id,
          status: 0
        }
      });
    }
  },
  mounted: function() {
    this.VideoCollectList();
  },
  watch: {
    // activeName: function() {
    //   this.VideoCollectList();
    // }
  }
};
</script>

<style scoped>
@import "../../../../assets/css/imgListFlow.css";
.imgListFlow li {
  position: relative;
}
.maskbox {
  position: absolute;
  top: 0px;
  border-radius: 5px;
  background: rgba(0,0,0, 0.1);
  width: 100%;
  height: 250px;
  z-index: 2000;
}
</style>


// WEBPACK FOOTER //
// src/components/personalcenter/common/fartabpane/videofar.vue